import { Directive } from '@angular/core';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import { TableListGridProviderDirective } from '@app/components/table-list-grid/directives/table-list-grid-provider.directive';
import {
  ListView,
  ListViewProviderDirective,
  ViewProviderDirective
} from '@ntap/core';
import { map, Observable } from 'rxjs';

@Directive({
  selector: '[appOdabirOsobeProvider]',
  providers: [
    {
      provide: ListViewProviderDirective,
      useExisting: OdabirPovezaneOsobeProviderDirective
    },
    {
      provide: ViewProviderDirective,
      useExisting: OdabirPovezaneOsobeProviderDirective
    },
    {
      provide: ParentListViewProvider,
      useExisting: OdabirPovezaneOsobeProviderDirective
    },
    {
      provide: TableListGridProviderDirective,
      useExisting: OdabirPovezaneOsobeProviderDirective
    }
  ],
  inputs: ['viewState', 'viewName']
})
export class OdabirPovezaneOsobeProviderDirective extends TableListGridProviderDirective {
  private readonly ALLOWED_ACTION_NAMES = [
    'openItem',
    'multiselect',
    'newItem',
    'newSeupSubjekt',
    'editSeupSubjekt'
  ];

  override get view$(): Observable<ListView> {
    return super.view$.pipe(
      map((view: any) => ({
        ...view,
        actions: view.actions.filter((a: any) =>
          this.ALLOWED_ACTION_NAMES.includes(a.name)
        )
      }))
    );
  }
}
